<div
  box-layout
  color="secondary-surface"
  [fullHeight]="true"
  elevation="raised"
  borderRight="light"
>
  <div
    box-layout
    paddingTop="lg"
    paddingBottom="sm"
    paddingHorizontal="lg"
    [grow]="1"
  >
    <Text role="title-small" color="on-tertiary-container-variant">MENU</Text>
  </div>
  @for (route of menu.navigableItems(); track route.path) {
    <ng-container
      [ngTemplateOutlet]="menuItem"
      [ngTemplateOutletContext]="route"
    ></ng-container>
  }
</div>

<ng-template
  #menuItem
  let-path="path"
  let-title="title"
  let-data="data"
  let-children="children"
>
  <div
    box-layout
    [routerLink]="path"
    routerLinkActive="active-link"
    (isActiveChange)="handleActiveRoute($event, path)"
    paddingVertical="sm"
    paddingLeft="md"
    paddingRight="md"
    [color]="
      children && activePath() === path ? 'primary-surface' : 'transparent'
    "
    [class.active-non-parent-link]="!children && activePath() === path"
    [class]="menuItemClass()"
  >
    <div
      row-layout
      alignItems="center"
      gap="sm"
      borderRadius="xs"
      paddingVertical="xs"
      paddingHorizontal="md"
    >
      <Symbol [name]="data?.symbol" [opticalSize]="20" />
      <div box-layout [width]="120">
        <Text role="headline-small">{{ title }}</Text>
      </div>
      @if (children && activePath() !== path) {
        <Symbol name="keyboard_arrow_down" [opticalSize]="40" />
      }
    </div>
  </div>
  <div box-layout color="primary-surface">
    @if (children) {
      <Expand [collapsed]="activePath() !== path">
        <div stack-layout paddingBottom="sm" [fullWidth]="true">
          @for (child of children; track child.data?.fullPath || child.path || child.title) {
            @if (child.children?.length) {
              <div row-layout paddingVertical="xs" paddingHorizontal="md">
                <div row-layout paddingHorizontal="md" paddingVertical="xs" alignItems="center" [grow]="1">
                  <Text role="headline-small" color="on-background-variant">
                    {{ child.title }}
                  </Text>
                </div>
              </div>
              @for (nestedChild of child.children; track nestedChild.data?.fullPath || nestedChild.path || nestedChild.title) {
                <ng-container
                  [ngTemplateOutlet]="submenuItem"
                  [ngTemplateOutletContext]="nestedChild"
                />
              }
            } @else {
              <ng-container
                [ngTemplateOutlet]="submenuItem"
                [ngTemplateOutletContext]="child"
              />
            }
          }
        </div>
      </Expand>
    }
  </div>
</ng-template>

<ng-template #submenuItem let-data="data" let-title="title">
  @if (!data?.hideInMenu) {
    <div
      row-layout
      [routerLink]="data.fullPath"
      routerLinkActive="active-link"
      paddingVertical="xs"
      paddingHorizontal="md"
      borderRadius="xs"
      [class]="submenuItemClass()"
    >
      <div
        row-layout
        paddingHorizontal="md"
        paddingVertical="xs"
        alignItems="center"
        [grow]="1"
        gap="sm"
        justifyContent="space-between"
      >
        <div row-layout alignItems="center" gap="sm">
          @if (data?.showIndicatorDot) {
            <span [class]="approvalIndicatorDotClass" aria-hidden="true"></span>
          }
          @if (data?.symbol) {
            <Symbol [opticalSize]="20" [name]="data?.symbol" />
          }
          <Text role="title-small">
            {{ title }}
          </Text>
        </div>
        @if (data?.badgeCount) {
          <div box-layout color="secondary-surface" borderRadius="xs" paddingHorizontal="xs" paddingVertical="xxs">
            <span [class]="badgeCountClass">{{ data.badgeCount }}</span>
          </div>
        }
      </div>
    </div>
  }
</ng-template>
